import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function SummerCamp() {
  const workshops = [
    { icon: '📚', title: 'Inglés', desc: '1 hora diaria de inglés donde aprenden divirtiéndose y jugando.' },
    { icon: '🥣', title: 'Cocina', desc: 'Los pequeños prepararán deliciosos platillos con sus propias manos.' },
    { icon: '🎨', title: 'Manualidades', desc: 'Fomentamos la creatividad con nuestras divertidas manualidades.' },
    { icon: '🎭', title: 'Teatro', desc: 'Crearán una obra de teatro desarrollando su creatividad y expresión.' },
    { icon: '🧪', title: 'Ciencia', desc: 'Para los pequeños curiosos: increíbles y seguros experimentos.' },
    { icon: '🎶', title: 'Baile', desc: 'Desarrollamos sus habilidades en nuestras clases de baile.' },
    { icon: '🏃', title: 'Deporte', desc: 'El desarrollo físico también importa. ¡Siempre en movimiento!' },
    { icon: '🎂', title: 'Fiestas de Cumpleaños', desc: 'Para nuestros pequeños cumpleañeros: fiesta con muchas sorpresas.' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Curso de Verano para Niños | Culturlingua — Tlaquepaque</title>
        <meta name="description" content="Summer Camp en Culturlingua Tlaquepaque. Inglés, cocina, manualidades, teatro, ciencia, baile y deporte para niños de 6 a 15 años." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Verano 2026</div>
        <h1>Summer Camp for Kids 🌞</h1>
        <p>Un verano único, lleno de aprendizaje, diversión y nuevas amistades.</p>
      </div>

      <section style={{background:'var(--navy)', padding:'0'}}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop={true}
          className="modern-swiper"
          style={{maxHeight:'480px'}}
        >
          {[
            { src: './assets/curso-verano1.webp', caption: 'Diversión y aprendizaje' },
            { src: './assets/curso-verano2.jpg', caption: 'Actividades dinámicas' },
            { src: './assets/curso-verano3.jpg', caption: 'Recreación interactiva' },
          ].map(({ src, caption }) => (
            <SwiperSlide key={caption}>
              <div className="gallery-card" style={{borderRadius:0}}>
                <img src={src} alt={caption} style={{height:'480px', width:'100%', objectFit:'cover'}} />
                <div className="caption" style={{fontSize:'1.1rem', padding:'40px 32px 24px'}}>{caption}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1100px', margin:'0 auto'}}>

          <div style={{background:'var(--navy-mid)', borderRadius:'20px', padding:'40px', marginBottom:'60px', display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'24px'}}>
            {[
              ['📅', 'Fechas', 'July 20 – August 14, 2026'],
              ['📍', 'Ubicación', 'Culturlingua Tlaquepaque'],
              ['👧🧒', 'Edades', '6 a 13 años'],
              ['🕒', 'Horario', 'Lun–Vie, 9:00am–2:00pm'],
            ].map(([icon, label, val]) => (
              <div key={label} style={{textAlign:'center'}}>
                <div style={{fontSize:'2rem', marginBottom:'8px'}}>{icon}</div>
                <div style={{color:'rgba(255,255,255,0.5)', fontSize:'0.75rem', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px'}}>{label}</div>
                <div style={{color:'white', fontWeight:'600', fontSize:'0.95rem'}}>{val}</div>
              </div>
            ))}
          </div>

          <div style={{textAlign:'center', marginBottom:'48px'}}>
            <div className="section-tag">Lo que incluye</div>
            <h2 className="section-headline">Talleres del Summer Camp</h2>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(240px, 1fr))', gap:'16px', marginBottom:'60px'}}>
            {workshops.map((w) => (
              <div key={w.title} style={{background:'white', borderRadius:'14px', padding:'24px', boxShadow:'0 2px 12px rgba(0,0,0,0.05)'}}>
                <div style={{fontSize:'2rem', marginBottom:'10px'}}>{w.icon}</div>
                <h3 style={{fontFamily:'Fraunces, serif', fontWeight:'700', fontSize:'1.05rem', color:'var(--navy)', marginBottom:'8px'}}>{w.title}</h3>
                <p style={{color:'var(--muted)', fontSize:'0.875rem', lineHeight:'1.6'}}>{w.desc}</p>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              📝 Inscripciones abiertas
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'32px'}}>
              ¡Asegura el lugar de tu hijo antes de que se llenen los grupos!
            </p>
            <Link to="/contacto" className="btn-glow">Inscribir ahora →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SummerCamp;
